import axios from 'axios'

export const http = axios.create({})

export const manageAuthHeadersFromProps = (props) => {
  if (!!props.invoiceFalconSessionId) {
    // Store token in localStorage
    localStorage.setItem('invoicefalcon_session_id', props.invoiceFalconSessionId)
    // Set token in HTTP headers
    http.defaults.headers.common['Authorization'] = `Bearer ${props.invoiceFalconSessionId}`

    return
  }

  // Retrieve token from localStorage
  const auth_token = localStorage.getItem('invoicefalcon_session_id');
  // Set token in HTTP headers
  http.defaults.headers.common['Authorization'] = `Bearer ${auth_token}`;
}

export const setInvoiceFalconSessionHeader = () => {
  // Retrieve token from localStorage
  const auth_token = localStorage.getItem('invoicefalcon_session_id');
  // Set token in HTTP headers
  http.defaults.headers.common['Authorization'] = `Bearer ${auth_token}`;
}

// Todo add axios interceptors to redirect to login in case we receive 403, authentication error from IF
